import { useEffect, useState } from 'react'
import QuestionEditable from "./question-editable";
import QuestionView from "./question-view";
import { useTranslation } from "react-i18next"
import './question.css'

const Question = (props) => {
  let { deleteQuestion, id, setTypeQuestion, data, handleChangeQuestion, editQuestionOptions, handleChangeQuestionOption, handleOptionDropDown, createNewQuestion, typeQuestion, setEditable, handleChangeConfig, changeQuestionOrder, lastQuestion, justShowDetails } = props

  const { t: tCommon, i18n, ready } = useTranslation('common')
  const [typeQuestionAux, setTypeQuestionAux] = useState([])

  useEffect(() => {
    if (ready) {
      const arrayAux = typeQuestion.map((item) => {
        const { name, ...otherValues } = item
        return { name: tCommon(name), ...otherValues }
      })

      setTypeQuestionAux(arrayAux)
    }
  }, [i18n.language, ready])


  return (
    <div className="question-card" style={{ margin: justShowDetails ? '30px 15px' : '24px 0' }}>
      {
        data.edit ?
          <QuestionEditable
            deleteQuestion={deleteQuestion}
            id={id}
            setTypeQuestion={setTypeQuestion}
            data={data}
            handleChangeQuestion={handleChangeQuestion}
            editQuestionOptions={editQuestionOptions}
            handleChangeQuestionOption={handleChangeQuestionOption}
            handleOptionDropDown={handleOptionDropDown}
            createNewQuestion={createNewQuestion}
            typeQuestion={typeQuestionAux}
            handleChangeConfig={handleChangeConfig}
          />
          :
          <QuestionView
            deleteQuestion={deleteQuestion}
            id={id}
            setTypeQuestion={setTypeQuestion}
            data={data}
            handleChangeQuestion={handleChangeQuestion}
            editQuestionOptions={editQuestionOptions}
            handleChangeQuestionOption={handleChangeQuestionOption}
            handleOptionDropDown={handleOptionDropDown}
            createNewQuestion={createNewQuestion}
            typeQuestion={typeQuestionAux}
            setEditable={setEditable}
            changeQuestionOrder={changeQuestionOrder}
            lastQuestion={lastQuestion}
            justShowDetails={justShowDetails}
          />
      }
    </div>
  )
}

export default Question